import {
  Checkbox,
  ControlLabel,
  FormControl,
  FormGroup,
  Glyphicon,
  InputGroup,
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import Tooltip from 'components/tooltip/Tooltip';
import useCopyToClipboard from 'hooks/useCopyToClipboard';
import { PresetNavigationRow } from './NavigationSettings.constants';
import { NavigationRowStyled } from './NavigationSettings.styles';

interface Props {
  row: PresetNavigationRow;
  showTooltip: boolean;
}

const NavigationPresetRow = ({ row, showTooltip }: Props) => {
  const { t } = useTranslation();
  const { getCopyAddonIcon } = useCopyToClipboard();

  return (
    <NavigationRowStyled data-testid={`navigation-preset-row-${row.key}`}>
      {row.titleFieldName ? (
        <TextField
          colSmInput={12}
          data-testid={`navigation-preset-${row.key}-name`}
          label={t(
            'pageDirectBookingEngine.navigationSettings.navigationTitle',
          )}
          labelOnTop
          name={row.titleFieldName}
          placeholder={row.name}
        />
      ) : (
        <FormGroup>
          <ControlLabel>
            {t('pageDirectBookingEngine.navigationSettings.navigationTitle')}
            {showTooltip && (
              <Tooltip
                id="navigation-title-tooltip"
                text={t(
                  'pageDirectBookingEngine.navigationSettings.navigationTitleTooltip',
                )}
              >
                <Glyphicon
                  data-testid="navigation-title-tooltip-icon"
                  glyph="info-sign"
                />
              </Tooltip>
            )}
          </ControlLabel>
          <FormControl
            data-testid={`navigation-preset-${row.key}-name`}
            disabled
            value={row.name}
          />
        </FormGroup>
      )}
      <FormGroup>
        <ControlLabel>
          {t('pageDirectBookingEngine.navigationSettings.navigationLink')}
        </ControlLabel>
        <InputGroup>
          <FormControl
            data-testid={`navigation-preset-${row.key}-url`}
            disabled
            placeholder={t(
              'pageDirectBookingEngine.navigationSettings.presetLinkPlaceholder',
            )}
            value={row.url}
          />
          <InputGroup.Addon>{getCopyAddonIcon(row.url)}</InputGroup.Addon>
        </InputGroup>
      </FormGroup>
      <Checkbox
        checked={false}
        data-testid={`navigation-preset-${row.key}-openInNewTab`}
        disabled
        readOnly
      >
        {t('pageDirectBookingEngine.navigationSettings.openInNewTab')}
      </Checkbox>
    </NavigationRowStyled>
  );
};

export default NavigationPresetRow;
